<div class="ui menu toolbar" paddingX="10" appPadding>
  <!-- <div class="ui container "> -->
  <div class="item header" style="margin-left: -22px; border: none">
    <img class="ui image logo" src="../../../assets/images/ncc-logo.svg" />
    <p class="header-text">E-services</p>

    <!-- <img class="ui image logo" src="./assets/images/logo.svg" popupText="A Data collection and analytics tool" /> -->
  </div>
  <div class="right menu">
    <div></div>
    <div
      class="user top right pointing ui dropdown item no-right-border"
      suiDropdown
    >
      <!-- <i class="table large icon"></i> -->
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.07035 7.41406H0V12.617H6.07035V7.41406Z" fill="white" />
        <path d="M12.445 13.7881H7.2421V19.9998H12.445V13.7881Z" fill="white" />
        <path d="M20 7.41406H13.6168V12.617H20V7.41406Z" fill="white" />
        <path d="M12.445 7.41406H7.2421V12.617H12.445V7.41406Z" fill="white" />
        <path d="M12.445 0H7.2421V6.24223H12.445V0Z" fill="white" />
        <path
          d="M6.07039 13.7883H0V17.7778C0 19.0031 0.996836 20 2.22215 20H6.07043V13.7883H6.07039Z"
          fill="white"
        />
        <path
          d="M17.7779 0H13.6166V6.24215H20V2.22215C20 0.996836 19.0031 0 17.7779 0Z"
          fill="white"
        />
        <path
          d="M13.6166 13.7883V19.9999H17.7778C19.0031 19.9999 20 19.0031 20 17.7778V13.7883H13.6166Z"
          fill="white"
        />
        <path
          d="M2.22215 0C0.996836 0 0 0.996836 0 2.22215V6.24219H6.07039V6.24215V0H2.22215Z"
          fill="white"
        />
      </svg>
      <!-- &nbsp;
      E-Services -->

      <i class="dropdown icon"></i>
      <div class="menu" suiDropdownMenu>
        <ng-template ngFor let-app [ngForOf]="apps">
          <a
            class="item"
            target="_blank"
            *ngIf="app.applicationHost !== currentHost"
            href="{{ baseUrl }}/identity/continue/?return_url={{
              app?.applicationHost
            }}"
          >
            <!-- <img class="ui  circular avatar image" 2="/assets/avatar/1.jpg"> -->
            {{ app?.applicationName }}</a
          >
        </ng-template>
      </div>
    </div>
    <div
      class="ui pointing top right dropdown item"
      style="align-self: flex-end"
      suiDropdown
    >
      <div class="msg">
        <i class="bell large icon" style="color: #fff"></i>
        <div class="floating ui red label mini circular">
          {{ totalUnread }}
        </div>
      </div>
      <div class="menu" suiDropdownMenu>
        <div class="ui grid basic fill attached segment no-padding">
          <div
            id="complaints"
            class="ui divided selection list"
            style="max-width: 500px; width: 500px; text-align: center"
            *ngIf="unRead && unRead.length > 0"
          >
            <div
              fxLayout="row"
              appPadding
              paddingY="5px"
              paddingX="2px"
              fxLayoutAlign="space-between center"
              *ngFor="let notification of unRead"
              style="
                margin-bottom: 0px;
                margin-top: 0px;
                border-bottom: 1px solid #e0dede !important;
              "
            >
              <div fxFlex="10%">
                <span
                  class="ui circular tiny empty red label"
                  *ngIf="notification.read != true"
                ></span>
                <span>
                  <i
                    class="large envelope outline icon"
                    [ngClass]="{ open: notification.read == true }"
                  ></i>
                  <!-- <i class="large email outline icon" style="margin-left: 15px;margin-top: 10px"></i> -->
                </span>
              </div>
              <div fxFlex="grow">
                <div
                  class="ui message"
                  style="
                    float: left;
                    padding: 0.2em 0.5em !important;
                    background: none !important;
                    -webkit-box-shadow: none !important;
                    box-shadow: none !important;
                  "
                >
                  <div class="header" style="font-size: 12px; text-align: left">
                    <a class="item" routerLink="/contractor/notifications">
                      {{ notification?.subject }}
                    </a>
                  </div>
                </div>
              </div>
              <div fxFlex="20%">
                {{ notification.dateCreated | amTimeAgo }}
              </div>
            </div>

            <div class="item" style="text-align: center">
              <a [routerLink]="['/contractor/notifications']"> See All </a>
            </div>
          </div>

          <div class="ui divided selection list" *ngIf="!optionPopulated">
            <div class="content" style="width: 450px; text-align: center">
              <h3 style="padding: 15%">
                <i class="big bell icon"></i>
                <br />
                No new notifications
              </h3>
            </div>
            <div class="ui divider" style="margin: 0px" *ngIf="total > 0"></div>
            <div style="text-align: center" *ngIf="total > 0">
              <a class="item" [routerLink]="['./notifications']"> See All </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="submenudrop"
      class="ui pointing top right dropdown item no-left-border"
      suiDropdown
    >
      <div class="company-info">
        <div class="company-name">
          {{
            user.organizationId.organizationLongName
              ? user?.organizationId?.organizationLongName
              : user?.organizationId?.organizationShortName
          }}
        </div>
        <div class="role-type">
          {{ user?.roleId?.roleName }}
        </div>
      </div>
      <img class="ui circular avatar image" [src]="photo" />

      <!-- hello team -->
      <i style="color: #fff" class="dropdown icon"></i>
      <div class="menu" suiDropdownMenu>
        <div style="width: 353px">
          <div fxLayout="row" style="padding: 24px 18px; align-items: center">
            <div fxFlex="30%">
              <div class="ui basic fill segment">
                <img
                  class="ui circular image"
                  style="object-fit: cover"
                  [src]="photo"
                />
              </div>
            </div>
            <div fxFlex="70%">
              <div class="ui basic fill segment" style="color: black">
                <div class="user-info">
                  <div class="user-name">
                    <strong
                      >{{ user?.firstName }} {{ user?.lastName }}
                      {{ user?.middleName }}</strong
                    >
                  </div>
                  <div class="role-name">
                    {{ user?.roleId?.roleName }}
                  </div>
                  <div
                    class="user-email"
                    style="
                      padding-bottom: 10px;
                      white-space: pre-line;
                      line-break: auto;
                      word-wrap: break-word;
                    "
                  >
                    {{ user?.appUserEmail }}
                  </div>
                </div>
                <a class="ui blue button" routerLink="/admin/setting/my-profile"
                  >My Profile</a
                >
              </div>
            </div>
          </div>
          <div
            fxLayout="row"
            class=""
            style="
              border-top: 1px solid #dededf;
              background: #f0f1f8;
              padding: 14px 18px;
              width: 100%;
            "
          >
            <div
              fxFlex
              class="ui basic fill segment"
              style="background: #f0f1f8 !important"
            >
              <div class="link" routerLink="/admin/setting/account-security">
                Change Password
              </div>
              <div class="ui divider" appMargin marginY="3"></div>
              <div class="link" (click)="logout()">Sign Out</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </div>

  <!-- </div> -->
</div>
<!-- <p class="warning-label">
  Note: Select the AOL assessment year above, then the company(s) with available
  record(s) will be displayed on the list of companies.
</p> -->
